export default function AttorneySection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Meet Robin J. Peterson
            </h2>
            <p className="text-base text-gray-600 mb-6 leading-relaxed">
              With over two decades of experience in workers' compensation law, Robin J. Peterson has dedicated his career to fighting for the rights of injured workers throughout Northeast Ohio. His deep understanding of Ohio's workers' compensation system and compassionate approach to client representation has helped thousands of workers secure the benefits they deserve.
            </p>
            <p className="text-base text-gray-600 mb-6 leading-relaxed">
              Robin believes that every injured worker deserves aggressive legal representation and personalized attention. He takes the time to understand each client's unique situation and develops strategies tailored to their specific needs. His commitment to excellence and client advocacy has earned him recognition as one of Northeast Ohio's leading workers' compensation attorneys.
            </p>
            <div className="space-y-4 mb-8">
              <div className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1"></i>
                <div>
                  <strong className="text-gray-900">Licensed in Ohio</strong>
                  <p className="text-sm text-gray-600">Admitted to practice before all Ohio courts</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1"></i>
                <div>
                  <strong className="text-gray-900">Workers' Compensation Specialist</strong>
                  <p className="text-sm text-gray-600">Exclusive focus on injured worker representation</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1"></i>
                <div>
                  <strong className="text-gray-900">Community Advocate</strong>
                  <p className="text-sm text-gray-600">Active member of Northeast Ohio legal community</p>
                </div>
              </div>
            </div>
            <div className="relative inline-block">
              <img
                src="https://public.readdy.ai/ai/img_res/0edfcd1a6abc717f71f4c35ae4055319.jpg"
                alt="Signature"
                className="h-16 w-auto"
              />
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-l-3xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/81164d3ba0f00c2a7e247a9f180c9b75/af33a34cf8804e3d9d9ab4a9ce6a769c.webp"
                alt="Robin J. Peterson"
                className="w-full h-auto object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-8 -left-8 bg-teal-600 text-white p-8 rounded-2xl shadow-xl max-w-xs">
              <div className="text-4xl font-bold mb-1">20+</div>
              <div className="text-sm">Years Fighting for Injured Workers</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}